import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '@app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-import-data',
  templateUrl: './import-data.component.html',
  styleUrls: ['./import-data.component.css']
})
export class ImportDataComponent implements OnInit {
  timeout: any;
  formGroup: UntypedFormGroup;
  formList:any[]=[];
  apiUrl:any = this.auth.apiUrl+'/sample';
  clientName:any=this.auth.getClientName();
  selectedFile: File | null = null;
  imageError:any;
  constructor(private formBuilder: UntypedFormBuilder, private auth: AuthService, private cdr: ChangeDetectorRef, private toastr: ToastrService) { }
  
  ngOnInit(): void {
    this.getFormList();
    this.formGroup = this.formBuilder.group({
        formName: [, Validators.required],
        otherName:[''],
        file:[]
    });
  }

  onFileSelected(fileInput: any) {
    this.selectedFile = fileInput.target.files[0];
  }

  getFormList(){
    this.auth.getMenuData().subscribe((res:any)=>{
      console.log(res);
      this.formList = res;
      this.formList.push({formName: "New Form", formUrl: "Other"});
    },(err:any)=>{
      console.log(err);
    })
  }


  onSubmit() {
    if (!this.selectedFile) return;

    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('formName', this.formGroup.controls['formName'].value);
    formData.append('otherName', this.formGroup.controls['otherName'].value);
    
      this.auth.importData(formData).subscribe((res:any)=>{
        this.formGroup.reset()
        this.toastr.success(res.message);
      },(err:any)=>{
        console.log(err);
        this.toastr.error(err.message);
      })
  }

}
